import { TitleButton as e, TitleLink as t } from "./styled/CarouselControls.styled.mjs";
import "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { ChevronRight as i } from "lucide-react";
//#region src/components/Carousel/CarouselTitle.tsx
var a = ({ title: a, icon: o, style: s, href: c, onClick: l }) => c ? /* @__PURE__ */ r(t, {
	style: s,
	href: c,
	onClick: l,
	$clickable: !0,
	children: [
		o,
		a,
		/* @__PURE__ */ n(i, { size: 15 })
	]
}) : /* @__PURE__ */ r(e, {
	style: s,
	$clickable: !!l,
	onClick: l,
	children: [
		o,
		a,
		l && /* @__PURE__ */ n(i, { size: 15 })
	]
});
//#endregion
export { a as CarouselTitle };
